// extracted by mini-css-extract-plugin
export default {"uoms-aliases-select":"UnitsOfMeasure_uoms-aliases-select__LzqgE","uoms-actions":"UnitsOfMeasure_uoms-actions__1YgRJ"};